import collectionPoster from '@/assets/images/autumn-harvest-collection.png';

export const order = 4;

export default {
  collection_name: 'Autumn Harvest Collection',
  collection_desc:
    '\nInspired by the warmth of autumn landscapes, the Autumn Harvest Collection brings together rich natural tones, subtle grain character, and timeless elegance.\n\nCrafted from Premium White Oak and finished with Sakura Floors\' Japanese-inspired design philosophy, this collection offers a refined balance of beauty, durability, and everyday livability. The wider plank format enhances the natural movement of the wood, creating inviting spaces that feel both sophisticated and welcoming.\n\nDesigned for homeowners who appreciate warmth, character, and enduring style, the Autumn Harvest Collection transforms every room into a place to gather, relax, and enjoy. Combining timeless craftsmanship with contemporary design, it creates an atmosphere that feels comfortable, refined, and effortlessly elegant for years to come.\n',
  collection_poster:
    collectionPoster,
  products: [
    {
      product_name: 'Misty Harbor 7.5',
      sku: '60201',
      product_desc:
        'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Misty%20Harbor%207.5/Misty%20Harbor%207.5%20Interior01.png',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Misty%20Harbor%207.5/Misty%20Harbor%207.5_1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Misty%20Harbor%207.5/Misty%20Harbor%207.5_2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Misty%20Harbor%207.5/Misty%20Harbor%207.5_3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Misty%20Harbor%207.5/Misty%20Harbor%207.5_4.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Misty%20Harbor%207.5/Misty%20Harbor%207.5%20video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Misty%20Harbor%207.5/Misty%20Harbor%207.5_1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Misty Harbor 7.5'],
        ['Grade', 'Prime'],
        ['Wear Layer', '3mm'],
        ['Width', '7.5"'],
        ['Thickness', '9/16"'],
        ['Length', 'Up to 75" with 70% full length'],
        ['Species', 'White Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Aurora Glow 7.5',
      sku: '5806',
      product_desc:
        'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Aurora%20Glow%207.5/Aurora%20Glow%207.5%20Interior01.jpg',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Aurora%20Glow%207.5/Aurora%20Glow%207.5_1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Aurora%20Glow%207.5/Aurora%20Glow%207.5_2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Aurora%20Glow%207.5/Aurora%20Glow%207.5_3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Aurora%20Glow%207.5/Aurora%20Glow%207.5_4.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Aurora%20Glow%207.5/Aurora%20Glow%207.5%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Aurora%20Glow%207.5/Aurora%20Glow%207.5_1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Aurora Glow 7.5'],
        ['Grade', 'Prime'],
        ['Wear Layer', '3mm'],
        ['Width', '7.5"'],
        ['Thickness', '9/16"'],
        ['Length', 'Up to 75" with 70% full length'],
        ['Species', 'White Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Golden Horizon 7.5 Prime',
      sku: '5912',
      product_desc:
        'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Golden%20Horizon%207.5%20Prime/Golden%20Horizon%207.5%20Prime%20Interior01.jpg',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Golden%20Horizon%207.5%20Prime/Golden%20Horizon%207.5%20Prime1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Golden%20Horizon%207.5%20Prime/Golden%20Horizon%207.5%20Prime2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Golden%20Horizon%207.5%20Prime/Golden%20Horizon%207.5%20Prime3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Golden%20Horizon%207.5%20Prime/Golden%20Horizon%207.5%20Prime4.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Golden%20Horizon%207.5%20Prime/Golden%20Horizon%207.5%20Prime%20%20Video1.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Golden%20Horizon%207.5%20Prime/Golden%20Horizon%207.5%20Prime1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Golden Horizon 7.5 Prime'],
        ['Grade', 'Prime'],
        ['Wear Layer', '3mm'],
        ['Width', '7.5"'],
        ['Thickness', '9/16"'],
        ['Length', 'Up to 75" with 70% full length'],
        ['Species', 'White Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Seashell Mist',
      sku: 'SS2X1-AH17',
      product_desc:
        'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Seashell%20Mist/Seashell%20Mist%20Interior01.jpeg',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Seashell%20Mist/Seashell%20Mist%2001.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Seashell%20Mist/Seashell%20Mist%2002.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Seashell%20Mist/Seashell%20Mist%2003.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Seashell%20Mist/Seashell%20Mist%2004.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Seashell%20Mist/Seashell%20Mist%20video%2001.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Seashell%20Mist/Seashell%20Mist%2001.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Seashell Mist'],
        ['Grade', 'Prime'],
        ['Wear Layer', '1.2mm'],
        ['Width', '7.5"'],
        ['Thickness', '1/2"'],
        ['Length', 'Up to 75" with 70% full length'],
        ['Species', 'White Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Steel Cloud',
      sku: 'SS2X2-AH18',
      product_desc:
        'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Steel%20Cloud/Steel%20Cloud%20Interior01.jpeg',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Steel%20Cloud/Steel%20Cloud1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Steel%20Cloud/Steel%20Cloud2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Steel%20Cloud/Steel%20Cloud3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Steel%20Cloud/Steel%20Cloud4.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Steel%20Cloud/Steel%20Cloud5.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Steel%20Cloud/Steel%20Cloud6.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Steel%20Cloud/Steel%20Cloud%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Steel%20Cloud/Steel%20Cloud1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Steel Cloud'],
        ['Grade', 'Prime'],
        ['Wear Layer', '1.2mm'],
        ['Width', '7.5"'],
        ['Thickness', '1/2"'],
        ['Length', 'Up to 75" with 70% full length'],
        ['Species', 'White Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Honey Comb',
      sku: 'SS2X3-AH19',
      product_desc:
        'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Honey%20Comb/Honey%20Comb%20Interior%2001.png',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Honey%20Comb/Honey%20Comb%2001.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Honey%20Comb/Honey%20Comb%2002.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Honey%20Comb/Honey%20Comb%2003.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Honey%20Comb/Honey%20Comb%2004.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Honey%20Comb/Honey%20Comb%2005.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Honey%20Comb/Honey%20Comb%20video%2001.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Honey%20Comb/Honey%20Comb%2001.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Honey Comb'],
        ['Grade', 'Prime'],
        ['Wear Layer', '1.2mm'],
        ['Width', '7.5"'],
        ['Thickness', '1/2"'],
        ['Length', 'Up to 75" with 70% full length'],
        ['Species', 'White Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Paris\'s Gaze',
      sku: 'SSX4-AH35',
      product_desc:
        'Rustic European Charm. Authentic, Lively Texture. Paris\'s Gaze beautifully captures the sun-bleached, historic allure of European countryside estates. Featuring a sophisticated, pale gray-beige wash—often called "greige"—this style softens the wood\'s tone while letting its natural story shine through. This combination makes it an exceptional foundational element for "Quiet Luxury," relaxed coastal, modern farmhouse, or refined organic modern interiors.',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Paris%27s%20Gaze/Paris%27s%20Gaze%20interior01.png',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Paris%27s%20Gaze/Paris%27s%20Gaze01.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Paris%27s%20Gaze/Paris%27s%20Gaze02.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Paris%27s%20Gaze/Paris%27s%20Gaze03.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Paris%27s%20Gaze/Paris%27s%20Gaze04.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Paris%27s%20Gaze/Paris%27s%20Gaze%20video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Paris%27s%20Gaze/Paris%27s%20Gaze01.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Paris\'s Gaze'],
        ['Grade', 'Select'],
        ['Wear Layer', '1.2mm'],
        ['Width', '7.5"'],
        ['Thickness', '1/2"'],
        ['Length', 'Up to 75" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Darcy\'s Pride',
      sku: 'SSX4-AH36',
      product_desc:
        'Regal Elegance. Timeless, Expressive Character. Darcy\'s Pride brings an air of historic sophistication and profound natural beauty to modern living spaces. Featuring a rich, warm amber-honey undertone, this premium hardwood style celebrates the innate strength and architectural grace of classic estates. It serves as an exquisite foundational element for high-end "Quiet Luxury," Scandi-Boho, or deeply inviting organic modern interiors.',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Darcy%27s%20Pride/Darcy%27s%20Pride%20interior01.png',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Darcy%27s%20Pride/Darcy%27s%20Pride01.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Darcy%27s%20Pride/Darcy%27s%20Pride02.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Darcy%27s%20Pride/Darcy%27s%20Pride03.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Darcy%27s%20Pride/Darcy%27s%20Pride04.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Darcy%27s%20Pride/Darcy%27s%20Pride%20video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Darcy%27s%20Pride/Darcy%27s%20Pride01.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Darcy\'s Pride'],
        ['Grade', 'Select'],
        ['Wear Layer', '1.2mm'],
        ['Width', '7.5"'],
        ['Thickness', '1/2"'],
        ['Length', 'Up to 75" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Anthony\'s Longing',
      sku: 'SSX4-AH37',
      product_desc:
        'Profound Depth. Dramatic, Rich Allure. Anthony\'s Longing brings a striking sense of mood, sophisticated contrast, and deep natural beauty to high-end interiors. Featuring a luxurious, deeply saturated smoky undertone, this premium hardwood style is engineered to anchor a room with undeniable presence. It serves as an exceptional foundation for spaces that lean into "Quiet Luxury," dramatic industrial design, or rich organic modernism.',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Anthony%27s%20Longing/Anthony%27s%20Longing%20interior01.png',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Anthony%27s%20Longing/Anthony%27s%20Longing01.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Anthony%27s%20Longing/Anthony%27s%20Longing02.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Anthony%27s%20Longing/Anthony%27s%20Longing03.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Anthony%27s%20Longing/Anthony%27s%20Longing04.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Anthony%27s%20Longing/Anthony%27s%20Longing%20video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Anthony%27s%20Longing/Anthony%27s%20Longing01.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Anthony\'s Longing'],
        ['Grade', 'Select'],
        ['Wear Layer', '1.2mm'],
        ['Width', '7.5"'],
        ['Thickness', '1/2"'],
        ['Length', 'Up to 75" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Helen\'s Glory',
      sku: 'AH55',
      product_desc:
        'Classic Artistry. Flawless Modern Symmetry. Helen\'s Glory brings the timeless, prestigious allure of traditional European parquet design into the modern era. Cut specifically for a precision herringbone installation pattern, this collection creates a captivating visual rhythm that adds architectural interest, depth, and upscale luxury to any room it graces.',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Helen%27s%20Glory/Helen%27s%20Glory%20interior%2001.png',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Helen%27s%20Glory/Helen%27s%20Glory01.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Helen%27s%20Glory/Helen%27s%20Glory02.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Helen%27s%20Glory/Helen%27s%20Glory03.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Helen%27s%20Glory/Helen%27s%20Glory04.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Helen%27s%20Glory/Helen%27s%20Glory05.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Helen%27s%20Glory/Helen%27s%20Glory06.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Helen%27s%20Glory/Helen%27s%20Glory%20video%2001.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Helen%27s%20Glory/Helen%27s%20Glory01.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Helen\'s Glory'],
        ['Grade', 'Light Character'],
        ['Wear Layer', '3.0mm'],
        ['Width', '5"'],
        ['Thickness', '9/16"'],
        ['Length', '24"'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Jayne\'s Delight',
      sku: 'AH56',
      product_desc:
        'Timeless Sophistication. Elegant Geometric Grace. Jayne\'s Delight brings an aura of classic luxury and architectural refinement to any interior. Crafted specifically for a precise herringbone installation, this collection turns your floor into a striking visual pattern that adds effortless depth, movement, and high-end European charm to both traditional and contemporary spaces.',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Jayne%27s%20Delight/Jayne%27s%20Delight%20interior%2001.png',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Jayne%27s%20Delight/Jayne%27s%20Delight01.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Jayne%27s%20Delight/Jayne%27s%20Delight02.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Jayne%27s%20Delight/Jayne%27s%20Delight03.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Jayne%27s%20Delight/Jayne%27s%20Delight04.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Jayne%27s%20Delight/Jayne%27s%20Delight05.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Jayne%27s%20Delight/Jayne%27s%20Delight%20video%2001.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Autumn%20Harvest%20Collection/Jayne%27s%20Delight/Jayne%27s%20Delight01.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Jayne\'s Delight'],
        ['Grade', 'Light Character'],
        ['Wear Layer', '3.0mm'],
        ['Width', '5"'],
        ['Thickness', '9/16"'],
        ['Length', '24"'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
  ],
};
